import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { NS } from '@/screens/Service/ducks/reducer';
import {
  getPublishedApiDoc,
  updateCrumbs
} from '@/screens/Service/ducks/actions';

import { PublishedPage } from '../../components/PublishedPage';

export const PublishedApiDoc = props => {
  const { updateCrumbs } = props;
  useEffect(() => {
    updateCrumbs([
      {
        label: 'Api Docs',
        path: `/services/${props.service.get('handle')}/api-docs`
      },
      { label: 'Api Doc' }
    ]);
  }, []);
  return <PublishedPage language="md" {...props} />;
};

const mapStateToProps = state => ({
  service: state.getIn([NS, 'service']),
  publishedPage: state.getIn([NS, 'publishedApiDoc']),
  pending: state.getIn([NS, 'pending', 'publishedApiDoc']),
  canEdit: state.getIn([NS, 'team', 'is_member'], false)
});
const mapDispatchToProps = dispatch => ({
  getPublishedPage: pageId => dispatch(getPublishedApiDoc(pageId)),
  updateCrumbs: crumbs => dispatch(updateCrumbs(crumbs))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublishedApiDoc);
